module.exports = __webpack_public_path__ + "img/weather-rain.0ebbfe73.png";